<!-- eslint-disable @typescript-eslint/explicit-module-boundary-types -->
<script lang="ts">
// oxlint-disable explicit-module-boundary-types
import type { Color } from 'nuxt-base/components/UiColorBubble.vue'

type StatusDelivery = NN<gen.SellerOrderUiStatusFragment['status']['delivery']>
type StatusOrder = NN<gen.SellerOrderUiStatusFragment['status']['order']>
type StatusPayment = NN<gen.SellerOrderUiStatusFragment['status']['payment']>
// type Status = NN<Statuses['status']['delivery' | 'order' | 'payment']>

export function createStatusUi() {
  const t2Map = {
    Canceled: 'Atšaukta',
    'Payment voided': 'Mokėjimas anuliuotas',
    'Payment disputed': 'Mokėjimas užginčytas',
    'Order received': 'Užsakymas gautas',
    'Payment confirmed': 'Mokėjimas patvirtintas',
    'Payment failed': 'Mokėjimas nepavyko',
    'Payment processing': 'Mokėjimas apdorojamas',
    'Payment received': 'Mokėjimas gautas',
    'Payment repeated': 'Mokėjimas pakartotas',
    'Payment transfer waiting': 'Laukiama mokėjimo pavedimo',
    'Payment transfer waiting - day 3': 'Laukiama mokėjimo pavedimo - 3 diena',
    'Payment transfer waiting - day 5': 'Laukiama mokėjimo pavedimo - 5 diena',
    Delivered: 'Pristatyta',
    Packing: 'Ruošiama',
    'Awaiting payment': 'Laukiama apmokėjimo',
    'Ready for collection': 'Paruošta atsiėmimui',
    Returned: 'Grąžinta',
    Shipped: 'Išsiųsta',
    'Partially Shipped': 'Išsiųsta',
    'In Transit': 'Kelyje',
    'Out for delivery': 'Išvežta pristatymui',
    Collected: 'Atsiimta',
    'Open Account': 'Atvira sąskaita',
  } as const satisfies Record<string, string>

  type TranslationKey = keyof typeof t2Map
  type StatusMapValue = { label: TranslationKey; color: Color }

  const lang = useLocale()
  const ltValue = computed(() => isLt(lang.value))

  function t2(key: TranslationKey): stringI18n {
    return (ltValue.value ? t2Map[key] : key) as stringI18n
  }

  function createGetStatusGetter<T extends Record<string, StatusMapValue>>(map: () => T) {
    const mapp = map()

    return computed(() => {
      return (status: keyof T | None): undefined | { color: Color; label: stringI18n } => {
        const end = status ? mapp[status] : undefined
        if (!end) return
        return { color: end.color, label: t2(end.label) as stringI18n }
      }
    })
  }
  const order = () =>
    ({
      Created: { label: 'Order received', color: 'grey' },
      PaymentAwaiting: { label: 'Awaiting payment', color: 'yellow' },
      Canceled: { label: 'Canceled', color: 'red' },
      PaymentReceived: { label: 'Payment received', color: 'green' },
      Packing: { label: 'Packing', color: 'yellow' },
      CollectionReady: { label: 'Ready for collection', color: 'green' },
      Returned: { label: 'Returned', color: 'blue' },
      Shipped: { label: 'Shipped', color: 'green' },
      ShippedPartially: { label: 'Partially Shipped', color: 'green' },
      Delivered: { label: 'Delivered', color: 'blue' },
      ReturnedPartially: { label: 'Returned', color: 'blue' },
      OpenAccount: { label: 'Open Account', color: 'black' },
    }) satisfies Record<gen.SellerOrderStatusUi, StatusMapValue>

  const statusMapPayment = () =>
    ({
      Voided: { label: 'Payment voided', color: 'blue' },
      Chargeback: { label: 'Payment disputed', color: 'red' },
      Canceled: { label: 'Canceled', color: 'red' },
      Created: { label: 'Awaiting payment', color: 'yellow' },
      PaymentConfirmed: { label: 'Payment confirmed', color: 'yellow' },
      PaymentFailed: { label: 'Payment failed', color: 'red' },
      PaymentFailedRepeatWarning: { label: 'Payment failed', color: 'red' },
      PaymentProcessing: { label: 'Payment processing', color: 'yellow' },
      PaymentReceived: { label: 'Payment received', color: 'green' },
      // PaymentAuthorised: { label: 'Payment received', color: 'green' },
      // PaymentRepeat: { label: 'Payment repeated', color: 'yellow' },
      PaymentTransferWaiting: { label: 'Payment transfer waiting', color: 'yellow' },
      PaymentTransferWaitingWarning: { label: 'Payment transfer waiting - day 3', color: 'red' },
      PaymentTransferWaitingLate: { label: 'Payment transfer waiting - day 5', color: 'red' },
      RefundedFully: { label: 'Returned', color: 'red' },
      RefundedPartially: { label: 'Returned', color: 'red' },
      OpenAccount: { label: 'Open Account', color: 'black' },
    }) satisfies Record<StatusPayment, StatusMapValue>

  const statusDelivery = () =>
    ({
      Created: { label: 'Order received', color: 'grey' },
      Delivered: { label: 'Delivered', color: 'green' },
      CollectionReady: { label: 'Ready for collection', color: 'green' },
      Returned: { label: 'Returned', color: 'blue' },
      Shipped: { label: 'Shipped', color: 'green' },
      ShippedPartially: { label: 'Partially Shipped', color: 'green' },
      Canceled: { label: 'Canceled', color: 'red' },
    }) satisfies Record<StatusDelivery, StatusMapValue>

  const statusOrder = () =>
    ({
      Created: { label: 'Order received', color: 'grey' },
      Packing: { label: 'Packing', color: 'yellow' },
      Accepted: { label: 'Shipped', color: 'green' },
      Denied: { label: 'Shipped', color: 'green' },
      Returned: { label: 'Returned', color: 'blue' },
      ReturnedPartially: { label: 'Returned', color: 'blue' },
    }) satisfies Record<StatusOrder, StatusMapValue>

  return {
    t2: () => t2,
    payment: () => createGetStatusGetter(() => statusMapPayment()),
    // order: () => createGetStatusGetter(() => statusOrder()),
    // delivery: () => createGetStatusGetter(() => statusDelivery()),
    orderUi: () => createGetStatusGetter(() => order()),
    all: () => createGetStatusGetter(() => ({ ...statusMapPayment(), ...statusOrder(), ...statusDelivery(), ...order() })),
  }
}
</script>

<script setup lang="ts">
const getStatusUi = createStatusUi().all()

const props = defineProps<{
  doc: None | Pick<gen.SellerOrderDocFullFragment, '_sf'>
  filterStatusByDate?: Date | None
  nolabel?: boolean
}>()
</script>

<template>
  <UiUserActivity
    v-bind="$attrs"
    :nolabel
    :filter-status-by-date="filterStatusByDate"
    :history="
      props.doc?._sf?.status?.history.map((i) => {
        return {
          at: i.at,
          ui: getStatusUi(i.status.delivery || i.status.order || i.status.payment),
        }
      })
    "
    :ui="(i) => ({ at: i.at, color: i.ui?.color, label: i.ui?.label })"
  />
</template>
